import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { PublicFaqCategory } from '../../models/public-faq-category';
import { PublicHtmlContentComponent } from '../public-html-content/public-html-content.component';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';
import { AnchorSectionComponent } from '@web/shared/ui';

@Component({
  selector: 'app-public-faq-categories',
  imports: [
    PublicHtmlContentComponent,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    AnchorSectionComponent,
  ],
  templateUrl: './public-faq-categories.component.html',
  styleUrl: './public-faq-categories.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicFaqCategoriesComponent {
  public readonly categories = input.required<PublicFaqCategory[]>();
}
